<ion-button
  fill="outline"
  [disabled]="isOffline()"
  (click)="showUploadFreightFileModal()"
>
  <ion-icon
    aria-hidden="true"
    slot="start"
    src="../assets/material-symbols/person_add_24dp.svg"
  ></ion-icon>
  Subir archivo de cargas
</ion-button>
